module.exports = __webpack_public_path__ + "placeholderwp9c7519bcb2fed352c39e466a597274c2.png";